import { centsToDollarString } from './constants';

export const EMPLOYMENT_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
];

export const PAY_BASIS_OPTIONS = [
  { value: 'hourly', label: 'Hourly' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'salary', label: 'Salary' },
  { value: 'fixed_other', label: 'Fixed / Other' },
];

export const payBasisLabel = (v) =>
  (PAY_BASIS_OPTIONS.find((o) => o.value === v) || {}).label || v;

export const EMP_SORT_OPTIONS = [
  { value: 'name_az', label: 'Name A–Z' },
  { value: 'recently_updated', label: 'Recently Updated' },
  { value: 'newest', label: 'Newest Added' },
  { value: 'oldest', label: 'Oldest Added' },
];

export const SUB_SORT_OPTIONS = [
  { value: 'name_az', label: 'Name A–Z' },
  { value: 'recently_updated', label: 'Recently Updated' },
  { value: 'newest', label: 'Newest Added' },
  { value: 'preferred_first', label: 'Preferred First' },
  { value: 'insurance_expiration_soonest', label: 'Insurance Expiration Soonest' },
];

export const INSURANCE_FILTER_OPTIONS = [
  { value: '', label: 'All Insurance' },
  { value: 'required', label: 'Insurance Required' },
  { value: 'on_file', label: 'Insurance On File' },
  { value: 'missing', label: 'Insurance Missing' },
  { value: 'expired', label: 'Insurance Expired' },
];

const PAY_SUFFIX = { hourly: '/ hour', daily: '/ day', weekly: '/ week' };

export const paySetupDisplay = (basis, cents) => {
  if (!basis && cents == null) return null;
  if (cents == null) return payBasisLabel(basis);
  const amt = centsToDollarString(cents);
  if (PAY_SUFFIX[basis]) return `${amt} ${PAY_SUFFIX[basis]}`;
  return basis ? `${amt} (${payBasisLabel(basis)})` : amt;
};

export const internalCostDisplay = (cents) =>
  cents == null ? null : `${centsToDollarString(cents)} / hour`;

export const PERSON_STATUS_STYLES = {
  active: 'bg-green-900/40 text-green-400 border-green-800',
  inactive: 'bg-gray-800 text-gray-400 border-gray-700',
};

export const isInsuranceExpired = (s) =>
  Boolean(
    s.insurance_on_file &&
      s.insurance_expiration_date &&
      s.insurance_expiration_date < new Date().toISOString().slice(0, 10)
  );
